import React from 'react';
import ReactDOM from 'react-dom/client';  
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Suppress benign ResizeObserver loop errors often thrown by browsers during layout
const originalConsoleError = console.error;
console.error = (...args) => {
  if (
    typeof args[0] === 'string' &&
    args[0].includes('ResizeObserver loop completed with undelivered notifications')
  ) {
    return;
  }
  originalConsoleError(...args);
};

// Load Zoho Desk ASAP widget once at app startup.
const injectZohoDeskWidget = () => {
  if (document.getElementById('zohodeskasapscript')) return;

  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.id = 'zohodeskasapscript';
  script.defer = true;
  script.src =
    'https://desk.zoho.com/portal/api/web/asapApp/1295234000000435148?orgId=919691638';

  const firstScript = document.getElementsByTagName('script')[0];
  if (firstScript?.parentNode) {
    firstScript.parentNode.insertBefore(script, firstScript);
  } else {
    document.body.appendChild(script);
  }

  window.ZohoDeskAsapReady = (callback) => {
    const queue = window.ZohoDeskAsap__asyncalls || [];
    window.ZohoDeskAsap__asyncalls = queue;

    if (window.ZohoDeskAsapReadyStatus) {
      if (callback) queue.push(callback);
      queue.forEach((queuedCallback) => queuedCallback && queuedCallback());
      window.ZohoDeskAsap__asyncalls = null;
    } else if (callback) {
      queue.push(callback);
    }
  };
};

injectZohoDeskWidget();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
      {process.env.LOCAL_ENV === "dev" && (
      <meta name="robots" content="noindex,nofollow" />
      )}
    <title>Doctors' Jobs</title>
    <link rel="apple-touch-icon" sizes="180x180" href="../public/favicon_io/apple-touch-icon.png"/>
    <link rel="icon" type="image/png" sizes="32x32" href="../public/favicon_io/favicon-32x32.png"/>
    <link rel="icon" type="image/png" sizes="16x16" href="../public/favicon_io/favicon-16x16.png"/>
    <link rel="manifest" href="../public/favicon_io/site.webmanifest"></link>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
